import React from "react";

const lookUpState = {
  allBagTypes: [],
  coinContainers: [],
  currencies: [],
  dispatch: () => {},
};

export const lookUpReducer = (state = lookUpState, { type, payload }) => {
  switch (type) {
    case "SET_BAG_TYPES":
      return { ...state, allBagTypes: payload };
    case "SET_COIN_CONTAINERS":
      return { ...state, coinContainers: payload };
    case "SET_CURRENCY_LIST":
      return { ...state, currencies: payload };
    default:
      return state;
  }
};

export default lookUpState;
export const LookUpContext = React.createContext(lookUpState);
